import { useCallback } from 'react';

import { logToNewRelic } from '../../../services/debug';
import type { PlayerQuest } from '../../../stores/quest/types';
import { EnumOpenDialog } from '../../../stores/ui/types';
import { useStores } from '../../../stores/useStores';
import { getErrorMessage } from '../../../utils/errors';

interface UseQuestWidgetData {
  event: PlayerQuest;
}

export function useQuestWidgetData(props: UseQuestWidgetData) {
  const { event } = props;
  const { questStore, uiStore } = useStores();

  const widgetImageUrl = event.widgetImageUrl;

  const handleClick = useCallback(() => {
    try {
      questStore.sendAnalyticsEvent({
        event_action: 'impression',
        params: {
          triggered_by: 'click',
          click_location: 'widget',
        },
      });

      void questStore.refreshMilestoneProgress();
      uiStore.setOpenDialog({ dialog: EnumOpenDialog.isOpenQuestDialog });
    } catch (e) {
      const errorMessage = getErrorMessage(e);
      logToNewRelic('Quest widget click error', errorMessage, 'error');
    }
  }, [questStore, uiStore]);

  const onTimerEnd = useCallback(() => {
    const randomDelayMS = (Math.floor(Math.random() * (5 - 1 + 1)) + 1) * 1000;

    setTimeout(() => {
      void questStore.fetch();
    }, randomDelayMS);
  }, [questStore]);

  return { widgetImageUrl, handleClick, onTimerEnd };
}
